import { useState } from 'react';
import { ReadinessData, saveReadiness } from '../api/client';
import { haptic } from '../lib/telegram';
import './ReadinessCard.css';

export const ReadinessCard: React.FC<{
  userId: number;
  readiness: ReadinessData;
  onChange: (value: ReadinessData) => void;
}> = ({ userId, readiness, onChange }) => {
  const [editing, setEditing] = useState(!readiness.checkin);
  const [sleep, setSleep] = useState(readiness.checkin?.sleep_hours || 7);
  const [fatigue, setFatigue] = useState(readiness.checkin?.fatigue || 3);
  const [soreness, setSoreness] = useState(readiness.checkin?.soreness || 2);
  const [mood, setMood] = useState(readiness.checkin?.mood || 4);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      onChange(await saveReadiness(userId, {
        sleep_hours: sleep, fatigue, soreness, mood
      }));
      setEditing(false);
      haptic.success();
    } finally {
      setSaving(false);
    }
  };

  if (!editing && readiness.score != null) {
    return (
      <section className="readiness-card result">
        <div className="readiness-score"><strong>{readiness.score}</strong><span>/100</span></div>
        <div><span className="readiness-kicker">ГОТОВНОСТЬ СЕГОДНЯ</span><h2>{readiness.level}</h2><p>{readiness.recommendation}</p></div>
        <button onClick={() => setEditing(true)}>Обновить</button>
      </section>
    );
  }

  return (
    <section className="readiness-card">
      <span className="readiness-kicker">ЕЖЕДНЕВНЫЙ ЧЕК-ИН</span>
      <h2>Как вы себя чувствуете?</h2>
      <p>Займёт меньше минуты и скорректирует рекомендацию на сегодня.</p>
      <div className="checkin-grid">
        <label><span>Сон, часов</span><input type="number" min="0" max="14" step=".5" value={sleep} onChange={event => setSleep(Number(event.target.value))} /></label>
        <label><span>Усталость · {fatigue}/5</span><input type="range" min="1" max="5" value={fatigue} onChange={event => setFatigue(Number(event.target.value))} /></label>
        <label><span>Мышцы · {soreness}/5</span><input type="range" min="1" max="5" value={soreness} onChange={event => setSoreness(Number(event.target.value))} /></label>
        <label><span>Настрой · {mood}/5</span><input type="range" min="1" max="5" value={mood} onChange={event => setMood(Number(event.target.value))} /></label>
      </div>
      <button className="checkin-save" onClick={save} disabled={saving}>{saving ? 'Считаем…' : 'Рассчитать готовность'}</button>
    </section>
  );
};
